import { Button, Modal } from "react-bootstrap";
import cross from "../../../../assets/images/cross.svg";
import vipBellPng from "../../../../assets/images/vipBellPng.png";
import BubbleSvgButton from "../BubbleSvgButton/BubbleSvgButton";// Ensure CSS is loaded and applies by importing with correct relative path and verifying the file exists
import "./ConfirmModal.css";

const ConfirmModal = ({ show, onHide, title, description, confirmText, onConfirm, className = "", loading = false }) => {
  return (
    <div>
      <Modal
        backdrop="false"
        onHide={loading ? undefined : onHide}
        // centered
        show={show}
        className={`confirmModal ${className}`.trim()}
      >
        <Modal.Body>
          <div className="modalContent">
            <Button className="closeBtn" onClick={onHide} disabled={loading}>
              <img alt="Close Modal" src={cross} />
            </Button>
            <div className="flexBox">
              <div className="img-box">
                <img alt="Bell" src={vipBellPng} />
              </div>
              <div className="content-box">
                <p>
                  <span>{title}</span>
                  <br />
                  {description}
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="buttonDiv d-flex algn-items-center justify-content-center w-100">
          <BubbleSvgButton
            onClick={onConfirm}
            text={confirmText}
            type="button"
            variant="black"
            isLoading={loading}
            disabled={loading}
            containerStyling={{ justifyContent: "center", padding: 0 }}
            mainDivStyle={{ width: "156px", height: "46px" }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
